import React from "react";

const ThreePMSME = () => {
  return (
    <div className="bg-black text-white [&_p]:text-white [&_li]:text-gray-200 min-h-screen p-4">

      <div className="mx-auto max-w-4xl">

        <h1 className="text-lg lg:text-2xl font-bold text-yellow-200 mb-4">
          💼 3P for MSME / Owners
        </h1>

        <h2 className="text-sm lg:text-lg text-purple-300 mb-4">
          Story: Ramesh’s “Tomorrow Evening” Promise
        </h2>

        <p className="text-gray-300 mb-4">
          It is <b>11:30 AM</b> in Ramesh’s fabrication workshop.
          Machines are humming, sparks fly from the welding station,
          and workers are busy cutting metal plates.
        </p>

        <p className="text-gray-300 mb-4">
          Ramesh runs a small fabrication unit producing custom metal components
          for local industries.
        </p>

        <p className="text-gray-300 mb-4">
          A customer walks in carrying a sample part.
        </p>

        <p className="text-yellow-200 mb-6">
          “Ramesh ji, I need 20 brackets like this. How long will it take?”
        </p>

        <p className="text-gray-300 mb-4">
          Ramesh glances at the sample for a few seconds and replies confidently:
        </p>

        <p className="text-yellow-200 mb-6">
          “No problem… come tomorrow evening.”
        </p>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          The Next Day Reality
        </h2>

        <ul className="list-disc list-inside text-gray-300 space-y-1 mb-6">
          <li>10:00 AM — Cutting machine suddenly stops</li>
          <li>11:30 AM — Two workers call in sick</li>
          <li>Metal plates require extra grinding</li>
          <li>Production slows down significantly</li>
        </ul>

        <p className="text-gray-300 mb-4">
          By evening only <b>14 brackets</b> are finished.
          The remaining work will take another full day.
        </p>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          The Real Cost of a Wrong Estimate
        </h2>

        <p className="text-gray-300 mb-4">
          At <b>6:00 PM</b>, the customer arrives expecting the order.
        </p>

        <p className="text-gray-300 mb-4">
          Ramesh hesitates and says:
        </p>

        <p className="text-red-300 mb-6">
          “There was a small delay… please come tomorrow.”
        </p>

        <p className="text-gray-300 mb-4">
          The customer leaves disappointed.
        </p>

        <div className="bg-gray-900 p-4 rounded mb-6">

          <p className="text-gray-300 mb-2">
            Without proper estimation:
          </p>

          <ul className="list-disc list-inside text-gray-300 space-y-1">
            <li>Delivery promise was broken</li>
            <li>Customer trust reduced</li>
            <li>Future orders may go elsewhere</li>
            <li>Workshop reputation suffers</li>
          </ul>

        </div>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          The Planning Tool Most MSMEs Never Use
        </h2>

        <p className="text-gray-300 mb-4">
          During an industry meeting, Ramesh learns about a professional planning method:
        </p>

        <div className="bg-gray-900 p-4 rounded mb-6">
          <p className="text-yellow-200 font-semibold">
            Think5Whys PTM 3P Estimation
          </p>
          <p className="text-gray-300 text-sm">
            A structured way to estimate time using three realistic scenarios.
          </p>
        </div>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          How Ramesh Could Estimate the Same Job
        </h2>

        <div className="bg-gray-900 p-4 rounded mb-6">

          <table className="w-full text-left text-sm">

            <thead className="text-yellow-200">
              <tr>
                <th>Estimate</th>
                <th>Time</th>
              </tr>
            </thead>

            <tbody className="text-gray-300">
              <tr>
                <td>Optimistic (O)</td>
                <td>5 hours</td>
              </tr>

              <tr>
                <td>Most Likely (M)</td>
                <td>8 hours</td>
              </tr>

              <tr>
                <td>Pessimistic (P)</td>
                <td>12 hours</td>
              </tr>
            </tbody>

          </table>

        </div>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          Think5Whys PTM 3P Calculation
        </h2>

        <div className="bg-gray-900 p-4 rounded mb-6">

          <p className="text-gray-300 mb-2">
            <b>Triangular Estimate</b>
          </p>

          <p className="text-yellow-200 mb-4">
            (5 + 8 + 12) / 3 ≈ 8.3 hours
          </p>

          <p className="text-gray-300 mb-2">
            <b>PERT Estimate</b>
          </p>

          <p className="text-yellow-200">
            (5 + 4×8 + 12) / 6 ≈ 8.2 hours
          </p>

        </div>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          What Ramesh Would Do Differently
        </h2>

        <p className="text-gray-300 mb-4">
          Instead of saying:
        </p>

        <p className="text-red-300 mb-4">
          “Come tomorrow evening.”
        </p>

        <p className="text-gray-300 mb-4">
          He would say:
        </p>

        <p className="text-green-300 mb-6">
          “This job will take about 8–9 hours of production time.
          I will deliver it tomorrow morning.”
        </p>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          Using 3P Across the Entire Business
        </h2>

        <ul className="list-disc list-inside text-gray-300 space-y-1 mb-6">
          <li>Estimating manufacturing time</li>
          <li>Preparing customer quotations</li>
          <li>Planning machine maintenance</li>
          <li>Scheduling workers and shifts</li>
          <li>Planning delivery commitments</li>
          <li>Estimating project completion</li>
        </ul>

        <h2 className="text-lg font-semibold text-purple-300 mb-3">
          The Final Realization
        </h2>

        <p className="text-gray-300 mb-2">
          One evening Ramesh noticed something unusual.
        </p>

        <p className="text-yellow-200 text-lg">
          “Earlier I was guessing delivery times… now I estimate them.”
        </p>

      </div>

    </div>
  );
};

export default ThreePMSME;